import styled from "@emotion/styled";
import {Box, Button} from "@mui/material";
import {media} from "assets/css/media";

export const PoolWrapper = styled(Box)`
	position: relative;
	width: 100%;
	background: var(--thirdColor);
	overflow-y: auto;

	h5 {
		color: #fff;
		padding: 16px 16px;
		font-size: 16px;
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 700;
		line-height: 130%;
		border-bottom: 1px solid #c7c7cc;

		@media (max-width: ${media.mobile}) {
			padding: 15px;
		}
	}
`;

export const FilterWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 16px;
	width: 100%;
	position: sticky;
	top: 0;
	background: #001436;
	z-index: 9;

	form {
		background: #172948;

		.MuiInputBase-input {
			color: #fff !important;
		}

		svg {
			path {
				fill: #c7c7cc !important;
			}
		}
	}
`;

export const ListWrapper = styled(Box)`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	justify-content: center;
	padding: 10px 20px 85px;
	overflow-y: auto;
`;

export const PlayerCardWrapper = styled(Box)<{isSelected?: boolean}>`
	border-radius: 8px;
	border: 4px solid #fff;
	background: #fff;
	min-height: 140px;
	height: 200px;

	width: 100%;
	max-width: 320px;
	color: var(--thirdColor);

	&.usa {
		.remove_btn {
			background: #fff;

			svg {
				path {
					fill: var(--secondaryColor);
				}
			}
		}
	}

	&:last-child {
		margin-bottom: 80px;
	}
`;

export const PlayerCardContainer = styled(Box)`
	width: 100%;
	height: 100%;
	position: relative;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
`;
export const PlayerData = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 8px;
	box-sizing: border-box;
	border-bottom: 1px solid var(--thirdColor);
	margin-bottom: 10px;
`;
export const PlayerStats = styled(Box)`
	display: flex;
	flex-direction: column;

	p {
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 400;
		font-size: 11px;
		line-height: 130%;
		display: flex;
		align-items: center;
		letter-spacing: -0.4px;
		color: var(--thirdColor);

		span {
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 130%;
			display: flex;
			align-items: center;

			color: var(--thirdColor);
			margin-left: 3px;
		}
	}

	em {
		display: inline;
		width: 8px;
	}
`;
const Cell = styled(Box)`
	display: flex;
	flex: 1 1 50%;
`;
export const InfoCell = styled(Cell)`
	flex-direction: column;
	padding: 15px 14px 15px 6px;
	box-sizing: border-box;
	flex: 1 1 58%;
`;
export const ImageCell = styled(Cell)<{isSelected: boolean}>`
	display: flex;
	align-items: end;
	justify-content: center;
	flex: 1 1 40%;
	box-sizing: border-box;
	border-radius: 8px;
	overflow: hidden;
	background: #011536;

	&.europe {
		background: ${({isSelected}) =>
			isSelected && "linear-gradient(180deg, #0076EB 0%, #003C82 100%)"};
	}
	&.usa {
		background: ${({isSelected}) =>
			isSelected && "linear-gradient(180deg, #FB4D56 0%, #FF0019 100%)"};
	}

	img {
		display: block;
		width: 100%;
		max-height: 182px;
	}
`;
export const AddButton = styled(Button)`
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%) rotate(45deg);
	width: 32px;
	height: 32px;
	max-width: 100px;
	border-radius: 50%;
	background: var(--primaryColor);
	min-width: auto;

	&:hover {
		background: var(--primaryColor);
	}

	&:disabled {
		background: grey;

		&:hover {
			background: grey;
		}
	}
`;
export const AddButtonWhite = styled(AddButton)`
	background: #fff;
	top: 8px;
	right: 8px;
	transform: translateY(0) rotate(45deg);
`;
export const RemoveButton = styled(Button)`
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: #c20000;
	min-width: auto;

	&:hover {
		background: #c20000;
	}
`;
export const RemoveButtonWhite = styled(RemoveButton)`
	top: 8px;
	right: 8px;
	transform: translateY(0);
`;

export const Flag = styled(Box)`
	display: flex;
	flex: 0 1 22px;
	width: 22px;
	height: 13px;
	overflow: hidden;
	border-radius: 3px;

	&.final_slot {
		position: absolute;
		top: 6px;
		right: 6px;
		width: 22px;
		height: 13px;
	}

	img {
		width: 100%;
		display: block;
	}
`;
